$(document).ready(function () {
  if ($('body').hasClass('error404')) {
    doThe404();
    $(window).on('resize', function () {
      doThe404();
    });
  }

  function doThe404() {
    var footerHeight = $("footer").outerHeight();
    var windowHeight = window.innerHeight;
    var sectionSelectorHeight = $(".border-container").outerHeight();
    var correctOffsetHeight = windowHeight - footerHeight;
    $(".border-container").css("height", correctOffsetHeight+"px");
  }
});